import { Parser } from 'json2csv';
/**
 * Function to convert an array of objects to a CSV string
 */
export function json2csv(data, headers) {
    const CsvParser = new Parser();
    return CsvParser.parse(data, { fields: headers });
}
